import { Grid } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import { api } from "../../services/api";
import CardSys from "../cardSys";
import MultiSelectGroup from "../multiSelectGroups";
import SelectEnterprise from "../selectEnterprise";
import InputPassword from "../generic/inputPassword";
import InputEmail from "../generic/inputEmail";
import InputName from "../generic/inputName";
import { Box } from "@mui/system";
import ConfirmPassword from "../generic/inputConfirmPassword";
import SubTitlePages from "../generic/subTitlePages";
import ButtonSave from "../buttonSave";
import CloseButton from "../generic/closeButton";
import SwitchStatus from "../generic/switchStatus";
import ButtonMaster from "../buttonMaster";
import { useNavigate } from "react-router-dom";

export default function CreateUser({ handleClose, userEdit, updateTable }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate()
  const [companyPermited, setCompanyPermited] = useState("");
  const [enterpriseSelected, setEnterpriseSelected] = useState(
    
    !userEdit
      ? {
          label: "VERSUO SOLUÇÕES FINANCEIRAS / 25886008",
          id: 25886008,
          name: "VERSUO SOLUÇÕES FINANCEIRAS",
        }
      : {
          label: "VERSUO SOLUÇÕES FINANCEIRAS / 25886008",
          id: 25886008,
          name: "VERSUO SOLUÇÕES FINANCEIRAS",
        }
  );
  const [groupsSelected, setGroupsSelected] = useState("");
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const [status, setStatus] = useState(0);
  const [masterButton,setMasterButton] = useState(false)
  // const []
  const { user } = useContext(AuthContext);

  const permissionUser = [];
  user?.permission?.map((el) => {
    if (el.name == "Usuários") {
      permissionUser.push(...el.permission);
    }
  });

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      handleToast(true, "error", "Senhas diferentes!");
      return;
    }
    if (!enterpriseSelected?.id) {
      handleToast(true, "error", "Selecione um cliente");
      return;
    }
    
    if (!companyPermited.length && (user?.id_client != 25886008 || !masterButton)) {
      handleToast(true, "error", "Selecione uma empresa de acesso");
      return;
    }
    
    if (!groupsSelected.length) {
      handleToast(true, "error", "Selecione um grupo");
      return;
    }
    handleLoading(true);

    const group = [];
    groupsSelected.map((el) => {
      group.push(el.id);
    });

    const companyPermited2 = []
    if (companyPermited2.length > 0) {
      companyPermited2 = companyPermited?.map((comp) => {
        return comp?.id;
      });
    }

    try {
      const { data } = await api({
        method: "POST",
        url: "/user",
        data: {
          name,
          email,
          password,
          confirmPassword,
          id_client: enterpriseSelected?.id,
          name_client: enterpriseSelected?.name,
          groupsSelected: group,
          companyPermited: companyPermited2,
          enterpriseSelected,
          status: !!status ? 1 : 0,
          master: !!masterButton ? true : false
        },
      });
      handleToast(true, data.toast, data.message);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
    updateTable();
  };



  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <CardSys>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Grid container component="form" onSubmit={handleSubmit}>
            <Grid
              item
              sx={{ display: "flex" }}
              justifyContent="space-between"
              alignItems="center"
              xs={12}
            >
              <SubTitlePages sx={{ display: "flex" }}>
                <SubTitlePages sx={{ fontWeight: "bold", marginRight: "4px" }}>
                  Novo Usuário
                </SubTitlePages>
              </SubTitlePages>
              <CloseButton onClick={handleClose}></CloseButton>
            </Grid>
            <Grid item xs={12}>
            <SelectEnterprise

            title="Empresa"
                disabled={userEdit}
                handleSelected={(elemento) => setEnterpriseSelected(elemento)}
              ></SelectEnterprise>
              
              <Grid item xs={12} sx={{ marginTop: "17px" }}>
                <InputName
                  onChange={(event) => setName(event.target.value)}
                  sx={{ background: "transparent" }}
                />
              </Grid>
              <Grid item xs={12} sx={{ marginTop: "17px",marginBottom:"17px" }}>
                <InputEmail
                  onChange={(event) => setEmail(event.target.value)}
                  sx={{ background: "transparent" }}
                />
              </Grid>
              <SelectEnterprise 
                title="Empresas que o usuário tem acesso"
                multiple
                disabled={userEdit}
                handleSelected={(elemento) => setCompanyPermited(elemento)}
              ></SelectEnterprise>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "17px" }}>
              <MultiSelectGroup
              title="Criar com base no perfil"
                handleSelected={(elemento) => setGroupsSelected(elemento)}
              ></MultiSelectGroup>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "17px" }}>
              <InputPassword
                onChange={(event) => setPassword(event.target.value)}
                sx={{ background: "transparent" }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "17px" }}>
              <ConfirmPassword
                onChange={(event) => setConfirmPassword(event.target.value)}
                sx={{ background: "transparent" }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "17px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <SwitchStatus
                checked={!!status}
                onChange={() => setStatus(!status)}
              ></SwitchStatus>
            { user?.id_client == 25886008 && <ButtonMaster sx={{backgroundColor: masterButton ? "gold" : "light-gray"}} onClick={()=> setMasterButton(!masterButton)} onChange={() => setStatus(!masterButton)}>
              </ButtonMaster> }
            </Grid>
            <Grid
              container
              xs={12}
              sx={{
                marginTop: "17px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {!!permissionUser.find((el) => el.name == "Criar") ? (
                <ButtonSave onClick={handleSubmit}>Salvar</ButtonSave>
              ) : null}
            </Grid>
          </Grid>
        </Box>
      </CardSys>
    </Box>
  );
}
